import type { TFunction } from 'i18next'

const BUILTIN_ROLE_DISPLAY_KEY: Record<string, string> = {
  admin: 'role.builtinNames.admin',
  annotator: 'role.builtinNames.annotator',
  manual_recognizer: 'role.builtinNames.manual_recognizer',
  project_manager: 'role.builtinNames.project_manager',
  project_viewer: 'role.builtinNames.project_viewer',
}

const BUILTIN_ROLE_DESCRIPTION_KEY: Record<string, string> = {
  admin: 'role.builtinDescriptions.admin',
  annotator: 'role.builtinDescriptions.annotator',
  manual_recognizer: 'role.builtinDescriptions.manual_recognizer',
  project_manager: 'role.builtinDescriptions.project_manager',
  project_viewer: 'role.builtinDescriptions.project_viewer',
}

export const getRoleDisplayName = (roleName: string, t: TFunction): string => {
  const translationKey = BUILTIN_ROLE_DISPLAY_KEY[roleName]
  if (!translationKey) {
    return roleName
  }

  return t(translationKey, { defaultValue: roleName })
}

export const getBuiltinRoleNameCandidates = (
  keyword: string,
  t: TFunction
): string[] => {
  const normalizedKeyword = keyword.trim().toLowerCase()
  if (!normalizedKeyword) {
    return []
  }

  return Object.entries(BUILTIN_ROLE_DISPLAY_KEY)
    .filter(([roleName, translationKey]) => {
      const displayName = t(translationKey, { defaultValue: roleName })
      return displayName.toLowerCase().includes(normalizedKeyword)
    })
    .map(([roleName]) => roleName)
}

export const getRoleBuiltinDescription = (roleName: string, t: TFunction): string | null => {
  const translationKey = BUILTIN_ROLE_DESCRIPTION_KEY[roleName]
  if (!translationKey) {
    return null
  }

  return t(translationKey, { defaultValue: '' }) || null
}

export const formatRoleOptionLabel = (
  roleName: string,
  description: string | null | undefined,
  t: TFunction
): string => {
  const displayName = getRoleDisplayName(roleName, t)
  const resolvedDescription =
    getRoleBuiltinDescription(roleName, t) ?? description
  return resolvedDescription
    ? `${displayName} (${resolvedDescription})`
    : displayName
}
